/* unplugin-vue-components disabled */import { render } from "./DemoEditorLock.vue?vue&type=template&id=67b48359&scoped=true&ts=true"
import script from "./DemoEditorLock.vue?vue&type=script&lang=ts"
export * from "./DemoEditorLock.vue?vue&type=script&lang=ts"

import "./DemoEditorLock.vue?vue&type=style&index=0&id=67b48359&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b48359"]])

export default __exports__